import { cn } from "@omni/utils/styles";
import React from "react";

import { PopOver } from "../PopOver/popOver.component";
import "./tooltip.scss";

export type TooltipProps = {
    innerHTML?: string;
    title?: string;
    className?: string;
    children?: React.ReactNode;
};

const Tooltip = ({ innerHTML, title, className, children }: TooltipProps) => {
    return (
        <PopOver
            dismissable={true}
            title={title}
            innerHTML={innerHTML}
            anchorComponent={(
                setReference,
                getReferenceProps,
                popOverComponent
            ) => (
                <span className={cn("tooltip-component", className)}>
                    <i
                        ref={setReference}
                        className="tooltip-component__icon las la-info-circle"
                        {...getReferenceProps()}
                    />
                    {popOverComponent()}
                </span>
            )}
        >
            {children}
        </PopOver>
    );
};

export { Tooltip };
